<template>
	<div>
		<a-form-model  ref="addForm"  :model="editObj"   :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" :rules="rules" >
			<a-form-model-item label="所属小区">
				<a-input  :value  = "getNeighborName(editObj.neighborId)" :disabled="true"/>
			</a-form-model-item>
			<a-form-model-item label="采集器地址" prop="collectorAddr">
				<a-input  v-model="editObj.collectorAddr"/>
			</a-form-model-item>
			<a-form-model-item label="IMEI" prop="imei">
				<a-input  v-model="editObj.imei"/>
			</a-form-model-item>
			<a-form-model-item label="IMSI" prop="imsi">
				<a-input  v-model="editObj.imsi"/>
			</a-form-model-item>
			<a-form-model-item label="备注信息" prop="remark">
				<a-textarea :rows="6" placeholder="最多300字" :maxlength="300" v-model="editObj.remark"/>
			</a-form-model-item>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'neighborList',
			'editObj'
		],
		data(){
			return {
				rules:{
					collectorAddr:[{required:true,message:'请输入采集器地址',trigger: 'blur'}],
					imei:[{required:true,message:'请输入IMEI',trigger: 'blur'}],
				}, 
				submitFlag:false,
			}
		},
		methods:{
			getNeighborName(theNeighborId){
				let result = null;
				for(var i=0;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if(item.pId == theNeighborId){
						result =  item.neighborName;
						break;
					}
				}
				return result;
			},
			onSubmit:function(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						this.doSubmit();
					} else {
						return false;
					}
				});
			},
			onClose:function(flag){
				this.$emit('cancelEdit');
				if(flag){
					this.$emit('refreshList');
				}
			},
			doSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.EDIT_NB_COLLECTOR_URL);
				this.Api.fetchPostWithForm(url,this.editObj).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.onClose(true);
						this.$message.success('修改NB采集器成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				})
			},
		}
	}
</script>

<style>
</style>
